import { render, staticRenderFns } from "./side-nav.vue?vue&type=template&id=57c9ad5a&scoped=true&"
import script from "./side-nav.vue?vue&type=script&lang=ts&"
export * from "./side-nav.vue?vue&type=script&lang=ts&"
import style0 from "./side-nav.vue?vue&type=style&index=0&id=57c9ad5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c9ad5a",
  null
  
)

export default component.exports